import api from "../services/api";

// Category
export const addCategory = (data) => {
    return api.post('admin/prompt/add_category', data);
}

export const updateCategory = (data) => {
    return api.put('admin/prompt/update_category', data);
}

export const updateCategoryStatus = (data) => {
    return api.put('admin/prompt/update_category_status', data);
}

export const deleteCategory = (id) => {
    return api.delete('admin/prompt/delete_category', {
        data: { _id: id }
    });
}

export const getCategoryList = (queryParams = "") => {
    return api.get(`/admin/prompt/category_list${queryParams}`);
};

// Sub Category
export const addSubCategory = (data) => {
    return api.post('admin/prompt/add_sub_category', data);
}

export const updateSubCategory = (data) => {
    return api.put('admin/prompt/update_sub_category', data);
}

export const updateSubCategoryStatus = (data) => {
    return api.put('admin/prompt/update_sub_category_status', data);
}

export const deleteSubCategory = (id) => {
    return api.delete('admin/prompt/delete_sub_category', {
        data: { _id: id }
    });
}

export const getSubCategoryList = (queryParams = "") => {
    return api.get(`/admin/prompt/sub_category_list${queryParams}`);
};